module.exports = __webpack_public_path__ + "img/stick_hiver_raquette.683fbca5.svg";